var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-greetings"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.greeting))])]),_vm._v(" "),(_vm.greeting)?_c('div',[_c('button',{on:{"click":_vm.signOut}},[_vm._v("ログアウト")])]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af862e22","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/amplify/components/auth/Greetings.vue
// module id = null
// module chunks = 